import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { executeElementScripts } from '../../util';

class Player extends Component {
	static propTypes = {
		setPlayerLoaded: PropTypes.func.isRequired
	}

	shouldComponentUpdate() {
    	return false;
	}

	componentDidMount() {
		const { visible } = this.props;

		if (visible && window.setupMedia !== undefined) {
			window.setupMedia(this.mediaContainer, this.props.setPlayerLoaded);
			executeElementScripts(this.mediaContainer);
		}
	}

	render() {
		const { visible, iframe } = this.props;

		if (!visible) {
			return null;
		}

		if (iframe) {
			return <div className="container">
				<div className="embed-responsive-item" ref={(input) => { this.mediaContainer = input; }}>
					<img alt="media placeholder" className="img-responsive" src="http://placehold.it/1600x900?text=loading+media..." />
				</div>
			</div>;
		} else {
			return <div className="embed-responsive-item" ref={(input) => { this.mediaContainer = input; }}>
				<img alt="media placeholder" className="img-responsive" src="http://placehold.it/1600x900?text=loading+media..." />
			</div>;
		}
	}
};

export default Player;